"use strict";

import $ from "jquery";
import { isParsleyForm, isValid } from "../../demi/js/scripts/parsley";

let currentIndex = 0;

export function initInScope($scope) {
    $scope.find('.js-mice-step-form').each(function () {
        let $form = $(this);
        let $steps = $form.find('.js-mice-step-form__step');
        let $legendItems = $form.find('.js-mice-step-form__legend-item');
        let $nextBtn = $form.find('.js-mice-step-form__next');
        let $prevBtn = $form.find('.js-mice-step-form__prev');

        currentIndex = $steps.index($steps.filter('.is-current'));

        console.log('currentIndex', currentIndex);

        navigateTo(0, $form, $steps, $legendItems, $nextBtn, $prevBtn); // Start at the beginning

        $nextBtn.on('click', function () {
            if (isParsleyForm($form)) {
                if (isValid($form)) {
                    navigateTo(currentIndex + 1, $form, $steps, $legendItems, $nextBtn, $prevBtn);
                }
            }
        });

        $prevBtn.on('click', function () {
            navigateTo(currentIndex - 1, $form, $steps, $legendItems, $nextBtn, $prevBtn);
        });
    });
}

function navigateTo(index, $form, $steps, $legendItems, $nextBtn, $prevBtn) {
    let $submitBtn = $form.find('.js-mice-step-form__submit');

    $steps.eq(currentIndex).removeClass('is-current');
    $steps.eq(index).addClass('is-current');
    $legendItems.eq(currentIndex).removeClass('is-current');
    $legendItems.eq(index).addClass('is-current');

    if (index !== 0) {
        $prevBtn.removeAttr('hidden');
    } else {
        $prevBtn.attr('hidden', 'true');
    }

    if ($submitBtn.length && $nextBtn.length) {
        if (index >= $steps.length - 1) {
            $nextBtn.attr('hidden', 'true');
            $submitBtn.removeAttr('hidden');
            showResults($form.find('.js-mice-step-form__result'), $form);
        } else {
            $nextBtn.removeAttr('hidden');
            $submitBtn.attr('hidden', 'true');
        }
    }

    currentIndex = index;
}

function showResults($result, $form) {
    console.log('showResults')
    let $formElements = $form.find('input:not([type=hidden]), textarea, select');
    let inputStates = [];

    $formElements.each(function () {
        let $input = $(this);
        let dataSet = $input.data();

        if (!dataSet.miceStepFormHidden) {
            let newInputState;
            let label = dataSet.miceStepFormLabel ? dataSet.miceStepFormLabel : $input.attr('name')

            if ($input.prop('tagName') === 'SELECT') {
                let $option = $input.find('option:selected');
                newInputState = {
                    label: label,
                    value: $option.text() ? $option.text() : $input.val()
                };
            } else if ($input.data('multiselect')) {
                console.log('data-multiselect', $input.attr('data-labels'));
                newInputState = {
                    label: label,
                    value: $input.attr('data-labels')
                };
            } else {
                newInputState = {
                    label: label,
                    value: $input.val()
                };
            }

            if (newInputState) {
                inputStates.push(newInputState);
            }
        }
    });

    $result.empty();
    inputStates.forEach((element) => {
        if (!$(this).data('mice-step-form-hidden')) {
            $result.append(renderResultItem(element));
        }
    });
}

function renderResultItem(element) {
    return $('<li>')
        .append($('<strong>')
            .addClass('mr-2')
            .text(`${element.label}: `))
        .append(document.createTextNode(element.value));
}